import React, { FC, useState } from 'react';
import FlyerTable from './FlyerTable/FlyerTable';
import './FlyerManagement.css';
import Switch from 'react-ios-switch';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import Spacer from '~/components/Spacer/Spacer';
import useEventsWithFlyerPaginated from '~/hooks/building/flyer/useEventsWithFlyerPaginated';
import useFetchEventsWithFlyer from '~/hooks/building/flyer/useFetchEventsWithFlyer';

export const FlyerManagement: FC<any> = () => {
  const [showCompletedReports, setShowCompletedReports] = useState(false);

  const uncompletedData = useFetchEventsWithFlyer();
  const completedData = useEventsWithFlyerPaginated({ completed: true, enabled: showCompletedReports });

  const paginatedData = showCompletedReports ? completedData : uncompletedData;

  return (
    <div className='container'>
      <Breadcrumbs />
      <Spacer height={20} />
      <div className='completed-flyer-switch'>
        <Switch
          checked={showCompletedReports}
          onChange={(currentSwitchState: boolean) => {
            setShowCompletedReports(currentSwitchState);
            uncompletedData.clearSearch();
            completedData.clearSearch();
          }}
        />
        <div>Show Completed Flyers</div>
      </div>
      <FlyerTable
        showCompletedReports={showCompletedReports}
        paginatedData={paginatedData}
      />
    </div>
  );
};
